import React from 'react'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import HFTextInput from 'components/HFInputs/HFTextInput'

import styles from '../../Dialog.module.sass'
import InfoList from 'components/InfoList/InfoList'
import { mapOpinionTaskDetails } from 'controllers/TaskManager/TaskSubControllers/TaskDetailsControllers/detailsUtils'

import MedicalOpinion from 'models/MedicalOpinion'
import { useFetchList } from 'store'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

export const GenericOpinionTaskFields = (props) => {
	const { data } = props
	const { i18n } = useGlobal()

	const opinionUri = `/metadata/medical_opinion/${data?.opinionRequest?.opinionId}`

	const { contents } = useFetchList(
		[data?.opinionRequest?.opinionId && opinionUri],
		[data?.opinionRequest?.opinionId && MedicalOpinion.fromJSON]
	)

	const [medicalOpinion] = contents

	const details = mapOpinionTaskDetails(medicalOpinion, i18n)
	return (
		<>
			<InfoList items={details} />
			<fieldset>
				<VStack className={styles['observation-container']}>
					<h5>{i18n`Medical opinion`}</h5>
					<HFTextInput
						name='opinion'
						placeholder={i18n`Write your medical observation`}
						multiline={true}
						rows={5}
						noResize
					/>
				</VStack>
			</fieldset>
		</>
	)
}
